import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ITemplateImportProps } from "entity/templateImport/TemplateImport/TemplateImport";

const TemplateImport = lazyLoadWithRetry(() => import("./TemplateImport"));

export const RouteTemplateImport = (
    props: Omit<ITemplateImportProps, "history" | "location" | "match" | "tabId">,
) => (
    <RouteRelative
        path={routes.templateImport.details}
        render={(routerProps) => {
            return (
                <BTSuspense>
                    <TemplateImport
                        {...props}
                        {...routerProps}
                        tabId={parseInt(routerProps.match.params.tabId)}
                        externalJobId={routerProps.match.params.externalJobId}
                    />
                </BTSuspense>
            );
        }}
    />
);
